import { render, staticRenderFns } from "./AddInvoiceModal.vue?vue&type=template&id=b0b4f7da&scoped=true&"
import script from "./AddInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./AddInvoiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b4f7da",
  null
  
)

export default component.exports